import { exec, getApiToken } from '../utils';
import type {
  SubmitReviewArgs,
  SubmitReviewExecVariables,
  SubmitReviewExecResponse,
} from '@src/types';

const gql = String.raw;

/**
 * Submits a repair review with approval/rejection and updated pricing
 * Automatically exchanges JWT for badge token if needed
 * @param args - Review parameters including state, pricing, and issue updates
 * @returns Promise resolving to the repair UUID
 */
export const submitReview = async (
  args: SubmitReviewArgs
): Promise<{ uuid: string }> => {
  const { token } = sessionStorage;

  const apiToken = await getApiToken(token);

  const variables: SubmitReviewExecVariables = {
    ...args,
    token: apiToken,
  };

  const searchQuery = gql`
    mutation submitReviewRepair(
      $token: String!
      $uuid: String!
      $repairState: String!
      $repairRejectionReason: String
      $repairShippingPrice: Int
      $issueUpdates: [RepairIssueUpdateTypeRestUser!]!
    ) {
      restUser(token: $token) {
        repair(
          uuid: $uuid
        ) {
          submitReview(
            repairState: $repairState
            repairRejectionReason: $repairRejectionReason
            repairShippingPrice: $repairShippingPrice
            issueUpdates: $issueUpdates
          ) {
            uuid
          }
        }
      }
    }
  `;

  const data = await exec<SubmitReviewExecVariables, SubmitReviewExecResponse>(
    searchQuery,
    {
      variables,
    }
  );

  return data.restUser.repair.submitReview;
};
